<template>
  <div>
    <a-row>
      <g-master name="poll_category"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                ref="master"
                :parentData="ParentData"
                :beforeSend="master.beforeSend"
                @action="masterAction"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Acción')">
                <a-select
                  v-decorator="[
                    'accion',
                    { rules: [{ required: true, message: 'Valor requerido' }], initialValue: 'UPDATE' },
                  ]"
                >
                  <a-select-option value="UPDATE">
                    UPDATE
                  </a-select-option>
                  <a-select-option value="HIDE">
                    HIDE
                  </a-select-option>
                  <a-select-option value="SHOW">
                    SHOW
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="poll_question"
                          :label="$t('Pregunta')"
                          :formItemConfig="fiOptions"
                          :cache="false"
                          :selectConfig="{
                            mode:'multiple'
                          }"
                          :params="filtro_preguntas"
                          :decorator="['questions', { rules: [{ required: true, message: 'Valor requerido' }] }]"
              >
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Valor')">
                <a-input
                  v-decorator="['valor', { rules: [{ required: false }] }]"/>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-row>
    <a-row>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        string_value: '',
        filtro_preguntas: {},
        tipo_pregunta: {h_lookup_type: 'TIPO_PREGUNTA'},
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          beforeSend: (data) => {
            return {...data, questions: data.questions.toString()}
          },
          endpoint: 'poll_rule_acts',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Accion', dataIndex: 'accion', sorter: true},
              {title: 'Preguntas', dataIndex: 'questions', sorter: true},
              {title: 'Valor', dataIndex: 'valor', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'accion'},
            {name: 'questions'},
            {name: 'valor'}
          ]
        }
      }
    },
    props: ['id', 'pollId'],
    mounted () {
      this.filtro_preguntas = {id_poll: this.pollId}
    },
    computed: {
      ParentData () {
        return {
          id_poll_rule: this.id

        }
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            this.$refs.master.modal.form.setFieldsValue({
              questions: action.record.questions.split(',')
            })
            break
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Poll/PollRuleActs.vue